import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { useDispatch } from 'react-redux';
import { Typography, Container, Box, Grid, FormControlLabel, Switch } from '@material-ui/core';
import CustomBreadcrumbs from '../Breadcrumb';
import { useLocation } from 'react-router-dom';
import { getDefaultCheckpoints, getPV_planbyId } from '../../ReduxStore/CreatePlanSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const PVchecklist = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    const location = useLocation();
    const dispatch = useDispatch();
    const pathname = location.pathname.split('/');
    const SupplierName = decodeURIComponent(pathname[4]);
    const plan_id = pathname[3];
    console.log("ttttttt", plan_id)

    const [defaultCheckpoints, setDefaultCheckpoints] = useState();
    const [loading, setLoading] = useState(true);
    ; const [formData, setFormData] = useState({
        frequency: "",
        startDate: "",
    });

    const getCheckpoints = async () => {
        try {
            const action = dispatch(getDefaultCheckpoints(plan_id));
            const res = await action.unwrap();
            console.log("lllllllll", res.result);
            const { pv_checkpoints } = res.result;
            console.log("check000000", pv_checkpoints);
            setDefaultCheckpoints(pv_checkpoints)
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getPlanbyId = async () => {
        try {
            const action = dispatch(getPV_planbyId(plan_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setFormData({
                    ...formData,
                    frequency: res.result.PV_plan
                    [0].frequency,
                    startDate: res.result.PV_plan
                    [0].start_date,
                });
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getCheckpoints();
            await getPlanbyId();
            setLoading(false);
        };
        fetchData();
    }, [plan_id])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Checkpoint List
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Checkpoint List" />
                </Box>
                <Box className="add-checkpoint">
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Checkpoints List
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        <Grid item xs={4}>
                            <h4>Supplier Name</h4>
                        </Grid>
                        <Grid item xs={3}>
                            <h4>Checkpoint</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <h4>Frequency</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <h4>Start Date</h4>
                        </Grid>
                        <Grid item xs={1}>
                            <h4>Enabled</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {defaultCheckpoints && defaultCheckpoints.map((item, index) => (
                        <Grid container spacing={3} key={index} alignItems='center'>
                            <Grid item xs={4}>
                                {SupplierName}
                            </Grid>
                            <Grid item xs={3} style={{ cursor: "pointer" }}>
                                {item.check_point}
                            </Grid>
                            <Grid item xs={2}>
                                {formData.frequency}
                            </Grid>
                            <Grid item xs={2}>
                                {formData.startDate}
                            </Grid>
                            <Grid item xs={1}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={item.active}
                                            name="enabled"
                                            color="primary"
                                        />
                                    }
                                />
                            </Grid>
                        </Grid>
                    ))}
                    <hr />
                </Box>
                <ToastContainer />
            </Container>
        </Layout>
    );
};

export default PVchecklist;
